/**
 * The secret Acomba minted for this launch and gave to both the bridge and this app. Sent on every
 * bridge call; without it the bridge answers 401, because loopback alone does not tell it which local
 * process is asking.
 *
 * Kept per société: the bridge files nonces the same way, and two windows opened from two Acomba share
 * one origin, so a single slot let the second launch overwrite the nonce the first was still using.
 * localStorage because the callback may land in another tab, and no expiry because a stale value fails
 * as not-connected rather than mid-day.
 */

import { companyScopedKey } from './bridgeCompany';

const BRIDGE_NONCE_KEY = 'bridge-nonce';

export function setBridgeNonce(nonce: string | null | undefined): void {
    if (!nonce) return;

    try {
        localStorage.setItem(companyScopedKey(BRIDGE_NONCE_KEY), nonce);
    } catch {
        // Private mode / quota. Calls then go out without it, which the bridge reports as a refusal.
    }
}

export function getBridgeNonce(): string | null {
    try {
        const scoped = localStorage.getItem(companyScopedKey(BRIDGE_NONCE_KEY));
        if (scoped !== null && scoped.length > 0) return scoped;

        const legacy = localStorage.getItem(BRIDGE_NONCE_KEY);
        return legacy === null || legacy.length === 0 ? null : legacy;
    } catch {
        return null;
    }
}

export function clearBridgeNonce(): void {
    try {
        localStorage.removeItem(companyScopedKey(BRIDGE_NONCE_KEY));
        localStorage.removeItem(BRIDGE_NONCE_KEY);
    } catch {
        // Storage unavailable; nothing to remove.
    }
}
